import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueRouter from 'vue-router'
import axios from 'axios'

import moment from 'moment'
Vue.prototype.$moment = moment

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import routes from './routes'
import store from './store'

Vue.use(require('vue-moment'));

import browserDetect from 'vue-browser-detect-plugin';
Vue.use(browserDetect);

import VueHtmlToPaper from 'vue-html-to-paper'


const options = {
  name: '_blank',
  specs: [
   'fullscreen=no',
   'titlebar=yes',
   'scrollbars=no'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    `https://webapp.canem.net/myPrint.css`
  ]
}

Vue.use(VueHtmlToPaper, options)

Vue.use(BootstrapVue)
Vue.use(VueRouter)
const router = new VueRouter({mode: 'history', routes});

import App from './App.vue'
import authentication from './authentication'

Vue.config.productionTip = false

Vue.prototype.$auth = authentication
Vue.prototype.$store = store 

const axiosconfig = {
  baseURL: 'https://canemwebappapi.azurewebsites.net/',  // integrated with Bird Directory Auth
  //baseURL: 'https://localhost:5001/', 
  //baseURL: 'https://localhost:44397/',
  
  timeout: 60000,
};

Vue.prototype.$http = axios.create(axiosconfig);

// Init adal authentication - then create Vue app.
authentication.initialize().then(_ => {

  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')

});
